import { Flex, SystemStyleObject } from '@chakra-ui/react'
import React from 'react'
import IconTranscripts from '~/assets/svgs/icon-transcripts.svg?react'
import IconVoicemail from '~/assets/svgs/icon-voicemail.svg?react'
import { Text } from '~/components/core'
import { QuickActionButtonVariants } from '~/components/shared/componentStyles/QuickActionButton.style'
import { CustomTooltipActionButton } from '~/components/shared/CustomTooltip/CustomTooltipActionButton'
import { TranscriptInProgressToolTip } from '~/pages/Calls/CallDetails/TranscriptInProgressToolTip'
import { CallSentimentTooltip } from '~/pages/Calls/CallSentimentTooltip'
import { useTranscriptCellStyles } from '~/pages/Calls/componentStyles/CallsListItem.style'
import { Size } from '~/types/ThemeTypes'

import { VoicemailToolTip } from '../CallDetails/VoicemailToolTip'

interface TranscriptCellProps {
  columnStyles: SystemStyleObject
  hasVoicemail?: boolean
  callId: number
  pbxId: number
  transcriptId?: number
  customerSentimentScore?: number
  onTranscriptClick?: () => void
  onVoicemailClick?: () => void
  transcriptionStatus?: string
  voicemailId?: number
}
export const TranscriptCell = ({
  columnStyles,
  hasVoicemail,
  callId,
  pbxId,
  transcriptId,
  transcriptionStatus,
  onTranscriptClick,
  onVoicemailClick,
  customerSentimentScore,
  voicemailId,
}: TranscriptCellProps) => {
  const styles = useTranscriptCellStyles()

  const isTranscriptSentimentNegative =
    customerSentimentScore !== undefined && customerSentimentScore <= -1

  let showTranscriptIcon = false
  let transcriptIconVariant: QuickActionButtonVariants =
    QuickActionButtonVariants.Default_100
  let isTranscriptIconDisabled = false
  let tooltipMessage = ''
  let popoverContents: React.ReactNode = null

  if (transcriptionStatus === 'COMPLETED') {
    showTranscriptIcon = true
    transcriptIconVariant = isTranscriptSentimentNegative
      ? QuickActionButtonVariants.Destructive_100
      : QuickActionButtonVariants.Default_100

    if (transcriptId) {
      popoverContents = (
        <CallSentimentTooltip
          pbxId={pbxId}
          callId={callId}
          callerSentiment={1}
          officeSentiment={-1}
          isSummaryTooltip={true}
        />
      )
    } else {
      transcriptIconVariant = QuickActionButtonVariants.Greyed_Out
      isTranscriptIconDisabled = true
      tooltipMessage = 'No transcript available.'
    }
  } else if (transcriptionStatus === 'IN_PROGRESS') {
    showTranscriptIcon = true
    isTranscriptIconDisabled = true
    transcriptIconVariant = QuickActionButtonVariants.Pulsate_Blue
    popoverContents = (
      <TranscriptInProgressToolTip
        content={
          <Text>
            Transcript is currently being generated, please check back later.
          </Text>
        }
      />
    )
  } else if (transcriptionStatus === 'AUDIO_TOO_LONG') {
    showTranscriptIcon = true
    isTranscriptIconDisabled = true
    transcriptIconVariant = QuickActionButtonVariants.Greyed_Out
    popoverContents = (
      <TranscriptInProgressToolTip
        content={
          <Text>Transcript unavailable: the call audio was too long.</Text>
        }
      />
    )
  } else if (transcriptionStatus === 'AUDIO_TOO_SHORT') {
    showTranscriptIcon = false
  } else if (transcriptionStatus === 'INTERNAL') {
    showTranscriptIcon = false
  } else {
    showTranscriptIcon = false
  }

  return (
    <Flex sx={{ ...columnStyles, ...styles.container }}>
      <Flex sx={{ ...styles.wrapper }}>
        <Flex sx={{ ...styles.iconWrapper }}>
          {showTranscriptIcon && (
            <CustomTooltipActionButton
              icon={IconTranscripts}
              variant={transcriptIconVariant}
              size={Size.sm}
              tooltipText={tooltipMessage}
              onButtonClick={onTranscriptClick}
              popoverContents={popoverContents}
              isDisabled={isTranscriptIconDisabled}
            />
          )}
          {hasVoicemail && (
            <CustomTooltipActionButton
              icon={IconVoicemail}
              variant={QuickActionButtonVariants.Default_100}
              size={Size.sm}
              tooltipText=""
              popoverContents={
                hasVoicemail && (
                  <VoicemailToolTip
                    voicemailId={voicemailId ?? 0}
                    pbxId={pbxId}
                    callId={callId}
                  />
                )
              }
              onButtonClick={onVoicemailClick}
            />
          )}
        </Flex>
      </Flex>
    </Flex>
  )
}
